import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import Footer from './components/footer/Footer';
import { ConsolePage } from './pages/ConsolePage';
import { useState, useEffect } from 'react';
import { LoginPage } from './pages/LoginPage';
import { SummaryPage } from './pages/SummaryPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import Support from './pages/Support';
import './App.scss';
import { motion, AnimatePresence } from "motion/react"

function App() {

  const [remainingTime, setRemainingTime] = useState<number|null>(null);
  const [profilePic, setProfilePic] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [isSummaryVisible, setIsSummaryVisible] = useState(false);
  const [interviewFeedback, setInterviewFeedback] = useState('');

  useEffect(() => {
    const loadFromAPI = async () => {
      console.log("Making api request");
      const response = await fetch('/aiproxy/init');
      if (response.ok) {
        const responseJson = await response.json();
console.log(responseJson);
        console.log("Setting is logged in %s", responseJson.isLoggedIn);
        setIsLoggedIn(responseJson.isLoggedIn);
        setProfilePic(responseJson.profilePic);
        setRemainingTime(responseJson.credits);
      }
    };
    loadFromAPI();
  }, []);

  if (isLoggedIn === null) {
    // This behavior sucks. I need to learn how folks usually solve this for SPAs.
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div data-component="App">
        <div className="gradient-background"></div>
        <div className="noise"></div>
        <Navigation isLoggedIn={isLoggedIn} remainingTime={remainingTime} profilePic={profilePic} />

        <Routes>
          <Route
            path="/"
            element={isLoggedIn ? <Navigate to="/console" replace /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/login"
            element={
              isLoggedIn ? (
                <Navigate to="/console" replace />
              ) : (
              <LoginPage />
              )
            }
          />
          <Route
            path="/console"
            element={
              isLoggedIn ? (
                <AnimatePresence>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <ConsolePage remainingTime={remainingTime} setRemainingTime={setRemainingTime} profilePic={profilePic} setInterviewFeedback={setInterviewFeedback} />
                  </motion.div>
                </AnimatePresence>
              ) : (
              <Navigate to="/login" replace />
              )
            }
          />
          <Route path="/summary" element={<SummaryPage feedback={interviewFeedback} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/support" element={<Support />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
